import React, { FC } from "react";
import {
  CardIconWrapper,
  CardIconWrapperProps,
} from "../CardIconWrapper/CardIconWrapper";

import { Icon } from "@UI/Components/Icon/Icon";

import { VisaIcon } from "../../../Icons/Visa/Visa";

type Props = Omit<CardIconWrapperProps, "children">;

export const VisaCardIcon: FC<Props> = (props) => {
  return (
    <CardIconWrapper {...props}>
      <Icon as={VisaIcon} />
    </CardIconWrapper>
  );
};
